var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waiting texture-bg-css text-center text-grey"},[_c('Icon',{attrs:{"type":"md-build"}}),_vm._v(" 正在建设中……\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }